import styled from 'styled-components';
import { Swiper } from 'swiper/react';
import {
  fonts,
  media,
  slideToLeftArrowsColourSelectorAnimation,
  slideToRightArrowsAnimation,
  spacing,
} from '@storefront/lib-global/stylings';

export const CardSelectorContainer = styled.section`
  display: flex;
  flex-direction: column;
  gap: ${spacing.XXS};
  margin-top: 20px;

  @media ${media.greaterThan('lg')} {
    margin-top: 38px;
    max-width: 523px;
  }
`;

export const CardSelectorHeader = styled.legend`
  display: flex;
  justify-content: space-between;
`;

export const CardSelectorHeaderText = styled.span`
  ${fonts.Montserrat}
  font-size: 14px;
  line-height: 18px;

  @media ${media.greaterThan('lg')} {
    font-size: 16px;
    line-height: 28px;
  }
`;

export const CardSelectorArrowButtonWrapper = styled.div`
  align-items: center;
  display: flex;
  gap: 4px;

  .swiper-button-disabled {
    opacity: 40%;
    pointer-events: none;
  }

  .swiper-button-lock {
    display: none;
  }
`;

export const CardSelectorArrowButton = styled.button`
  background: none;
  border: none;
  display: flex;
  margin: 0;
  padding: 0;

  &.card-selector-prev {
    ${slideToRightArrowsAnimation}
  }

  &.card-selector-next {
    ${slideToLeftArrowsColourSelectorAnimation}
  }
`;

export const CardSelectorImageList = styled.div`
  height: 75px;
  width: 100%;
`;

export const CardSelectorCarousel = styled(Swiper)`
  height: 75px;
  width: 100%;

  .swiper-slide {
    width: 75px;
  }

  .swiper-wrapper {
    @media ${media.greaterThan('lg')} {
      max-width: 400px;
    }
  }
`;
